import styled from 'styled-components';

export const Container = styled.div`
  display: grid;

  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));

  gap: 18px;

  margin-bottom: 24px;
`;

export const Card = styled.div`
  background: ${props => props.darkMode === true ? '#1a1d24' : 'white'};
  
  border-radius: 14px;

  padding: 22px;

  display: flex;

  align-items: center;

  gap: 18px;

  box-shadow: 0 4px 18px rgba(0,0,0,.05);

  transition: .2s;

  &:hover {
    transform: translateY(-2px);

    box-shadow: 0 8px 24px rgba(0,0,0,.08);
  }
`;

export const IconWrapper = styled.div`
  width: 54px;

  height: 54px;

  border-radius: 12px;

  display:flex;

  align-items:center;

  justify-content:center;

  background:${props => props.background || '#EFF6FF'};
  color:${props => props.color || '#2563EB'};

  // color:white;

  font-size:24px;

  flex-shrink:0;
`;

export const Content = styled.div`
  display:flex;

  flex-direction:column;
`;

export const Title = styled.span`
  color:#6B7280;

  font-size:13px;
`;

export const Value = styled.span`
  font-size:28px;

  font-weight:700;

  color:#111827;
`;